import * as React from 'react'
import { I18n } from 'react-redux-i18n'

import './styles.scss'
import { Button } from 'components/Form'

const NoChannel = (props) => {
  return (
    <div className='animated fafeIn no-channel'>
      <img src='img/channels-view.png' alt='channels'/>
      <h1>{I18n.t('channels_no_channel')}</h1>
      <Button value={I18n.t('dashboard_add-channel')} primary className='button-add-channel' onClick={props.onClick}/>
    </div>
  )
}

export default NoChannel